import ContentfulEntry from 'models/data/contentful/ContentfulEntry'
import ContentfulImage from 'models/data/contentful/ContentfulImage'
import { get } from 'lodash'
import contentful from "libraries/contentful/client";

class ContentfulAuthor {
	static default = {
		fullName: "",
		shortBiography: "",
    picture: ContentfulImage.default,
    twitter: '',
    instagram: '',
		slug: ""
	};

    static id = contentfulAuthor => ContentfulEntry.id(contentfulAuthor)

    static fullName = contentfulAuthor => {
        const fields = ContentfulEntry.fields(contentfulAuthor);
        const fullName = get(fields, "fullName", ContentfulAuthor.default.fullName);
        return fullName;
    }

    static shortBiography = contentfulAuthor => {
        const fields = ContentfulEntry.fields(contentfulAuthor);
        const shortBiography = get(fields, 'shortBiography', ContentfulAuthor.default.shortBiography)
        return shortBiography
    }

    static picture = contentfulAuthor => {
        const fields = ContentfulEntry.fields(contentfulAuthor)
        const picture = get(fields, 'picture', ContentfulAuthor.default.picture)
        return picture
    }

    static twitter = contentfulAuthor => {
        const fields = ContentfulEntry.fields(contentfulAuthor)
        const twitter = get(fields, 'twitter', ContentfulAuthor.default.twitter)
        return twitter
    }

    static instagram = contentfulAuthor => {
      const fields = ContentfulEntry.fields(contentfulAuthor)
      const instagram = get(fields, 'instagram', ContentfulAuthor.default.instagram)
      return instagram
  }

		static slug = contentfulAuthor => {
        const fields = ContentfulEntry.fields(contentfulAuthor)
        const slug = get(fields, 'slug', ContentfulAuthor.default.slug)
        return slug
    }

    static async fetchWithId(authorId) {
		const entries = await contentful.getEntries({ content_type: "author", "sys.id": authorId });
		const [contentfulAuthor] = [...get(entries, "items", [])];
		return contentfulAuthor;
    }

		static async fetchWithSlug(authorSlug) {
		const entries = await contentful.getEntries({ content_type: "author", "fields.slug": authorSlug });
		const [contentfulAuthor] = [...get(entries, "items", [])];
		return contentfulAuthor;
    }
}

export default ContentfulAuthor;


//
// { sys:
//    { space:
//       { sys: { type: 'Link', linkType: 'Space', id: 'ssn6gmzvvg61' } },
//      id: '46jVtHAQBMjFXvHXgecGf9',
//      type: 'Entry',
//      createdAt: '2019-09-09T20:56:59.801Z',
//      updatedAt: '2019-09-09T20:56:59.801Z',
//      environment:
//       { sys: { id: 'staging', type: 'Link', linkType: 'Environment' } },
//      revision: 1,
//      contentType:
//       { sys: { type: 'Link', linkType: 'ContentType', id: 'author' } },
//      locale: 'en-US' },
//   fields:
//    { fullName: 'Mauktik Kulkarni',
//      shortBiography:
//       'Mauktik Kulkarni is an engineer, neuroscientist, entrepreneur, author and a filmmaker. He is the author of A Ghost of Che and Packing Up Without Looking Back. He has co-produced and co-anchored a travel film titled Riding on a Sunbeam with several others in the pipeline.',
//      picture:
//       { sys:
//          { space:
//             { sys: { type: 'Link', linkType: 'Space', id: 'ssn6gmzvvg61' } },
//            id: '6XjFEaAaDaFEO97t5FtNIc',
//            type: 'Asset',
//            createdAt: '2019-09-09T20:56:48.999Z',
//            updatedAt: '2019-09-09T20:56:48.999Z',
//            environment:
//             { sys: { id: 'staging', type: 'Link', linkType: 'Environment' } },
//            revision: 1,
//            locale: 'en-US' },
//         fields:
//          { title: 'Mautik-Kulkarni',
//            description: 'Mauktik Kulkarni',
//            file:
//             { url:
//                '//images.ctfassets.net/ssn6gmzvvg61/6XjFEaAaDaFEO97t5FtNIc/6122887fe5a4b3de5cc0bde49bd7d8c3/Mautik-Kulkarni.jpg',
//               details: { size: 47796, image: { width: 400, height: 400 } },
//               fileName: 'Mautik-Kulkarni.jpg',
//               contentType: 'image/jpeg' } } },
//      slug: 'mauktik-kulkarni' } }
//
